import { Badge } from "@/components/ui/badge";

import { jobBottleNeckToIcon, jobBottleneckToLabel } from "@/lib/constants";
import { JobBottleneck } from "@/types";

export const JobBottleneckBadge = ({
  bottleneck,
}: {
  bottleneck: JobBottleneck;
}) => {
  const Icon = jobBottleNeckToIcon[bottleneck];

  return (
    <Badge variant="secondary" className="gap-2 text-sm font-normal">
      <Icon className="h-3.5 w-3.5 text-slate-600" />
      {jobBottleneckToLabel[bottleneck]}
    </Badge>
  );
};
